// /ProfilePage/components/ProfileEditForm.js

import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardContent, Grid, Button, Box } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { StyledTextField } from './StyledTextField';

function ProfileEditForm({ user, onSave }) {
  const [userInfo, setUserInfo] = useState({ nome: '', email: '' });

  useEffect(() => {
    if (user) {
      setUserInfo({
        nome: user.nome || '',
        email: user.email || '',
      });
    }
  }, [user]);

  const handleInputChange = (e) => {
    setUserInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = () => {
    onSave({ nome: userInfo.nome });
  };

  return (
    <Card sx={{ bgcolor: '#2C2C2F', borderRadius: 3, height: '100%' }}>
      <CardHeader title="Editar Perfil" sx={{ borderBottom: '1px solid #444' }} />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <StyledTextField
              fullWidth
              label="Nome"
              name="nome"
              value={userInfo.nome}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              fullWidth
              label="Email"
              name="email"
              value={userInfo.email}
              disabled
            />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSubmit}
            color="primary"
          >
            Salvar Alterações
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default ProfileEditForm;
